/* Builder A · WF-12 Défi d’équipe seam (Bible §52 · v3.2.2 §7 · locked #19).
   What is measured is invitations offered — never reviews received, never
   ratings, never service quality. The team goal is the default; individual
   contributions are opt-in behind the employee notice, and the manager sees
   contributions, not a ranking. */
import { useQuery } from '@tanstack/react-query'

export type ChallengeMode = 'equipe' | 'individuel'

export interface Contribution { id: string; name: string; meta: string; count: number }

export interface Challenge {
  name: string; period: string; mode: ChallengeMode
  scope: string
  goal: number; achieved: number
  measure: string
  recognition: string
  contributions: Contribution[]
  /** improbable pattern → flagged for review, never an automatic accusation */
  flag: string | null
}

/** TC-03 — a participant sees their own attributed activity and nobody else’s. */
export interface SelfView {
  name: string; window: string
  eligibleSessions: number; giftsIssued: number
}

/** TC-04 — winner approval and the recorded fulfilment. */
export interface Closure {
  winner: string; winnerDetail: string
  fraudReviews: string
  recognition: string
  fulfilment: string
}

/** TC-05 — the period closed without the goal being met. */
export interface MissedPeriod {
  label: string
  goal: number; goalUnit: string
  achieved: number; achievedPct: number
  gap: number; gapNote: string
  closingDaysNote: string
  adjustedGoal: number
}

async function get<T>(path: string): Promise<T> {
  const res = await fetch(`/v1${path}`)
  if (!res.ok) throw new Error(`${res.status} on ${path}`)
  return res.json() as Promise<T>
}

export const useChallenge = () =>
  useQuery({ queryKey: ['challenge'], queryFn: () => get<Challenge>('/challenge') })
export const useSelfView = () =>
  useQuery({ queryKey: ['challenge', 'self'], queryFn: () => get<SelfView>('/challenge/self') })
export const useClosure = () =>
  useQuery({ queryKey: ['challenge', 'closure'], queryFn: () => get<Closure>('/challenge/closure') })
export const useMissedPeriod = () =>
  useQuery({ queryKey: ['challenge', 'missed'], queryFn: () => get<MissedPeriod>('/challenge/missed') })
